import type { PolymorphicRef, SizeKey, TypographyCode } from '@sds-system/types';
import type { ElementType } from 'react';
import { forwardRef } from 'react';
import { Typography } from '../Typography';
import { StyledButton } from './Button.styled';
import type { ButtonComponent, ButtonProps, ButtonVariant } from './Button.types';

const typographySizeVariant: (
  variant: ButtonVariant,
) => Record<Exclude<SizeKey, '2XS' | '3XS' | '3XL' | '4XL'>, TypographyCode> = () => {
  return {
    XS: 'caption.regular',
    S: 'body2.regular',
    M: 'body2.regular',
    L: 'body2.regular',
    XL: 'body.regular',
    '2XL': 'header3.regular',
  };
};

export const Button: ButtonComponent = forwardRef(
  <C extends ElementType = 'button'>(
    {
      children,
      variant = 'solid.primary',
      isRound = false,
      leftContent,
      rightContent,
      size = 'M',
      styledComponents,
      ...props
    }: ButtonProps<C>,
    ref: PolymorphicRef<C>,
  ) => {
    return (
      <StyledButton
        gap={8}
        isRound={isRound}
        ref={ref}
        size={size}
        variant={variant}
        {...props}
        {...styledComponents?.root}
      >
        {leftContent && leftContent}
        {children && (
          <Typography
            fontType={typographySizeVariant(variant)[size]}
            {...styledComponents?.children}
          >
            {children}
          </Typography>
        )}
        {rightContent && rightContent}
      </StyledButton>
    );
  },
);
